import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({
  title,
  description,
  image,
  locale,
  slug,
  imageFit = 'fill',
}) => {
  const query = useStaticQuery(graphql`
    query {
      allContentfulGeneralSettings(filter: { node_locale: { eq: "en-US" } }) {
        nodes {
          metaSiteTitle
          metaImage {
            title
            file {
              url
            }
          }
          metaDescription {
            metaDescription
          }
          node_locale
        }
      }
    }
  `);

  const site = query.allContentfulGeneralSettings.nodes[0];
  const metaTitle = title
    ? `${title} | ${site.metaSiteTitle}`
    : site.metaSiteTitle;

  const siteUrl = 'https://visit.kyrodistillery.com';
  const pageUrl = slug ? siteUrl + '/' + slug : siteUrl;

  const metaDescription = description
    ? description
    : site.metaDescription.metaDescription;

  const imageUrl = `https:${image.file.url || site.metaImage.file.url}`;
  const metaImage = {
    height: 630,
    width: 1200,
    url: `${imageUrl}?w=1200&h=630&fit=${imageFit}`,
  };

  return (
    <Helmet htmlAttributes={{ locale }} title={metaTitle} titleTemplate={`%s`}>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* General tags */}
      <meta name="image" content={metaImage.og} />
      <meta name="description" content={metaDescription} />
      <meta
        name="google-site-verification"
        content="ueW-OBiMX9zgMy5w2hlnP0xeW-41iHyPN5RXVLrKv7Y"
      />

      {/* OpenGraph tags */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={metaImage.url} />
      <meta property="og:image:width" content={metaImage.width} />
      <meta property="og:image:height" content={metaImage.height} />
      <meta property="og:description" content={metaDescription} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:image" content={metaImage.url} />
      <meta name="twitter:description" content={metaDescription} />

      {/* Pinterest site claim tag */}
      <meta name="p:domain_verify" content="61c65e574a2e0c704a765d22c41ac05f" />
    </Helmet>
  );
};

export default Seo;

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  locale: PropTypes.string,
  slug: PropTypes.string,
};
